
const objectRunState = {
  normal: 1,
  beyond: 2,
  delay: 3,
  moreDelay: 4
}

export const objectState = {
  open: 1,
  close: 2
}

export const objectOwnType = {
  okr: 1,
  project: 3
}

export { objectRunState };

export const objectRunStateList = [
  {
    id: objectRunState.normal,
    name: '正常'
  },
  {
    id: objectRunState.beyond,
    name: '超前'
  },
  {
    id: objectRunState.delay,
    name: '滞后'
  }
]


// WEBPACK FOOTER //
// ./src/config/okr.js